import React, { useState, useEffect } from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import "./sidebar.styles.css";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core";
import { useHistory  } from 'react-router';


const useStyles = makeStyles({
    link : {
        marginTop: "90px",
        marginLeft: "300px",
        width: "156px",
        height: "22px",
        textAlign: "left",
        font: "normal normal medium 18px/22px Montserrat",
        letterSpacing: "0px",
        color: "#FCFCFC",
        opacity: 1,
    }
})

function Sidebar(props) {
    
    const classes = useStyles()
    const CLOSED_POSITION = 100;
  

    const [xPosition, setX] = useState(-props.width);

    useEffect(() => {
        if (props.mostra) {
            toggleMenu();
        }

    }, [props.mostra]);
    //Position 
    useEffect(() => {
        setX(-CLOSED_POSITION);
    }, []);



    const handlePoppup = (e) => {
        props.handleClick();
        toggleMenu();
        props.setCountrySelected("")
        setTimeout(() => {
            window.location.reload()
           }); 
    }

    const toggleMenu = () => {
        if (xPosition < 0) { // 0 -> the sidebar is visible.
            setX(0);
        } else {
            setX(-CLOSED_POSITION);
        }
    };

    useEffect(() => {
        setX(-CLOSED_POSITION)
    }, []);

    const filteredPlace = props.eventsData.filter((el) => {
       
        return el.place === props.eventsData["place"]
    })

   const history = useHistory()

    return (
        <div>
            
        <div className='modal-wrapper'>
            <div style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'scroll', overflowX: 'hidden', marginTop: '-30px' }} className="modal fade hide-scrollbar" id="exampleModal3" role="dialog" aria-labelledby="exampleModalLabel3" aria-hidden="true">
                <div
                    className="modal-dialog modal-dialog-slideout"
                    style={{
                        transform: `translate(${xPosition}%)`, //xPosition is the position we set by using the hook.
                        maxWidth: props.width,
                        minHeight: props.height
                    }}
                    role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            {props.showEventsTable ? 
                            <div > 
                                <div style={{marginRight: '150px'}}> 
                                <div style={{marginTop: '5px'}}>
                                <ArrowBackIosIcon onClick={handlePoppup} style={{width: '23px', marginTop: '4px', marginLeft: '18px', color: 'white', marginRight: '-20px', cursor: 'pointer'}} />
                                  <button type="button" className="close globalMapButton" data-dismiss="modal" aria-label="Close" onClick={handlePoppup}>
                                   <p className="globalMapButton" style={{fontSize:'18px', fontFamily: 'Montserrat', color: 'white', marginBottom: '-25px', marginTop: '-5px'}}> Back to Global Map</p>
                                </button>
                                </div>
                              </div>
                                <h5 style={{marginTop: '5px'}} className="modal-title" id="exampleModalLabel">{props.countrySelected.toUpperCase()}'S EVENTS MAP</h5>
                             </div>   : 
                             
                             <div> 
                                <div style={{marginLeft: '20px', cursor: 'pointer'}}> 
                                 <div onClick={props.handleClickBack} style={{marginTop: '20px', marginBottom: '-35px'}}>
                               
                                

                                 
                                  <p className="globalMapButton" style={{fontSize:'18px', fontFamily: 'Montserrat', color: 'white', marginBottom: '-25px', marginTop: '-20px', paddingTop: '10px', marginBottom: '15px', marginLeft: '-30px'}}><ArrowBackIosIcon onClick={props.handleClickBack} style={{width: '23px', color: 'white', cursor: 'pointer', marginTop: '-4px', marginRight: '-7px', marginLeft: '30px' }} /> Back to {props.countrySelected.slice(0,1).toUpperCase() + props.countrySelected.slice(1)}'s Events</p>

                                  </div>
                             </div>

                                  <div style={{marginLeft: '-5px'}}>
                                  <h5 className="modal-title" style={{marginTop: '40px', fontFamily: 'Montserrat', fontWeight: '510', fontSize: '24px', whiteSpace: 'nowrap', marginLeft: '20px'}} id="exampleModalLabel"> {history.location.place.toUpperCase()}'S {history.location.eventType.toUpperCase()} NEWS </h5>
                                  <h5 style={{marginTop: '-8px'}} className="modal-title" id="exampleModalLabel">CIRCULATION MAP </h5>
                                  <p style={{fontFamily: 'Montserrat', fontSize: '12px', color: 'white', fontWeight: '200', marginLeft: '350px', marginTop: '2px', cursor: 'pointer', marginBottom: '-5px'}} onClick={() => history.push(`/tabpanel/${history.location.recordId}`, {place: history.location.place, eventType: history.location.eventType, eventDate: history.location.eventDate, eventDescription: history.location.eventDescription  }) }>Go to Event Page</p>
                                </div>
                             </div>
                                 }                        
                        </div>
                        <div
                            //when the nation is clicked, the panel will open
                            onClick={() => toggleMenu()}
                            className="toggle-menu"
                            style={{
                                //position of the button
                                transform: `translate(${props.width}px, 3vh)`
                            }}
                        > {/** arrow of the button: right or left */}
                            <i className={`fa fa-caret-${xPosition === 0 ? 'left' : 'right'}`} aria-hidden="true"></i>
                        </div>
                  
                        <div className="">
                            {/* <TabellaEventi country={props.country} eventsData={props.eventsData} filtersData={props.filtersData} /> */}
                            {props.children} 
                            {/**this is the content inside <Slide> </Slide> in the map. */}
                        </div> 

                        {/*} 
                        <div className="modal-footer">
                       
                        
                        </div> */}

                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Sidebar;